import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import SerializeForm from 'form-serialize';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { Radio, Checkbox } from 'rmwc/Radio';
import { connect } from 'react-redux'
import GooglePlacesAutoComplete from './GooglePlacesAutoComplete'
import StatusMessage from '../util/StatusMessage'
import PlacesAutoComplete from 'react-places-autocomplete'
import GoogleTagManager from '../util/GoogleTagManager'
import ReactGA from 'react-ga';
import { Card } from 'rmwc/Card';

class TPORegistration extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      tpoRefOther: false,
      data:{
        'firstName': '',
        'lastName': '',
        'email': '',
        'tpoRefereceList': [],
        'tpo_reference': '',
        'tpoReferenceSubList': [],
        'tpoReferenceSub': '',
        'teachingAssociations': [],
        'teachingAssociationId': '',
        'teachingAssociationName': '',
        'teachingAssociationOther': [],
        'teachingAssociationIdOther': '',
        'teachingAssociationNameOther': '',
        'workingPositions': [],
        'workingPositionId': '',
        'workingPositionName': '',
        'workingOrganization': '',
        'cityOfResidence': '',
        'countryId': '',
        'countryName': '',
        'countries': [],
        'stateId': '',
        'stateName': '',
        'states': [],
        'city': '',
        'testcenters': [],
        'testcenterId': '',
        'testCenterName': '',
        'testCenterCountryId': '',
        'testTrackPrimaryList': [],
        'testTrackPrimaryId': '',
        'testTrackPrimaryName':'',
        'testTrackOptionFirstList': [],
        'testTrackOptionFirstId': '',
        'testTrackOptionFirstName':'',
        'testTrackOptionSecondList': [],
        'testTrackOptionSecondId': '',
        'testTrackOptionSecondName':'',
        'optionFirstEnable': false,
        'optionSecondEnable': false,
        'countryFee':'',
        'testCycleId':'',
        'payment_modes': [],
        'paymentModeId' :'',
        'testLocations': [],
        'testLocationOne': '',
        "testLocationTwo": '',
        "referralCode": '',
        "discountValuePerTrack": 0, 
        "noOfSelectedTrack": 0, 
      },

      timeSlots:{
        'primarySlots': [],
        'optionFirstSlots': [],
        'optionSecondSlots': [],
        'primarySlotId':'',
        'optionFirstSlotId': '',
        'optionSecondSlotId': '',
        'primaryStart':'',
        'primaryStartM':'',
        'primaryEnd':'',
        'primaryEndM':'',
        'optionFirstStart': '',
        'optionFirstStartM': '',
        'optionFirstEnd':'',
        'optionFirstEndM':'',
        'optionSecondStart': '',
        'optionSecondStartdM': '',
        'optionSecondEnd': '',
        'optionSecondEndM': '',
        'testLocationPrefOne': '',
        'testLocationPrefTwo': ''
      },

       trackFee:{
        PrimaryFee:0,
        optionFirstFee:0,
        optionSecondFee:0,
        feeToBePaid:0,
      },

      formErrors:{
        'firstNameError':'',
        'lastNameError':'',
        'emailError': '',
        'cityOfResidenceError':'',
        'countryIdError':'',
        'stateIdError':'',
        'teachingAssociationIdError':'',
        'tpoReferenceError': '',
        'testCenterError': '',
        'testTrackPrimaryIdError':'',
        'primarySlotIdError':'',
        'paymentModeError':'',
        'optionFirstSlotIdError':'',
        'optionSecondSlotIdError':'',
        'workingOrganizationError':'',
        'discountCodeError':''
      },
      saveState:{
        saveDisabled: false
      },
      componentState:{
        first_disable:false,
        last_disable:false,
      }
    };

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleTPORefSelection = this.handleTPORefSelection.bind(this)
    this.handleTeachingAssociationSelection = this.handleTeachingAssociationSelection.bind(this)
    this.handleTeachingAssociationOtherSelection = this.handleTeachingAssociationOtherSelection.bind(this)
    this.handleworkingPositionSelection = this.handleworkingPositionSelection.bind(this)
    this.handleCountriesChange = this.handleCountriesChange.bind(this)
    this.handleCitySelect = this.handleCitySelect.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
    this.handleSchoolChange = this.handleSchoolChange.bind(this)
    this.handleSchoolSelect = this.handleSchoolSelect.bind(this)
    this.handleTestCenterChange = this.handleTestCenterChange.bind(this)
    this.handleTestTrackPrimaryChange = this.handleTestTrackPrimaryChange.bind(this)
    this.handleAddTestTrack = this.handleAddTestTrack.bind(this)
    this.handleTestTrackOptionFirstChange = this.handleTestTrackOptionFirstChange.bind(this)
    this.handleTestTrackOptionSecondChange = this.handleTestTrackOptionSecondChange.bind(this)
    this.getTimeSlotForTrack = this.getTimeSlotForTrack.bind(this)
    this.computeFeeToBePaid = this.computeFeeToBePaid.bind(this)
    this.handleTimeSlotChange = this.handleTimeSlotChange.bind(this)
    this.isTimeSlotOverlap = this.isTimeSlotOverlap.bind(this)
    this.transformPMHours = this.transformPMHours.bind(this)
    this.checkTimeOverlap = this.checkTimeOverlap.bind(this)
    this.handleTPORefSub = this.handleTPORefSub.bind(this)
    this.handlePaymentModeChange = this.handlePaymentModeChange.bind(this)
    this.handleStatesChange = this.handleStatesChange.bind(this)
    this.handleTestLocationOne = this.handleTestLocationOne.bind(this)
    this.handleTestLocationTwo = this.handleTestLocationTwo.bind(this)
    this.handleSubmitAndProceed = this.handleSubmitAndProceed.bind(this)
    this.handleDiscountApply = this.handleDiscountApply.bind(this)

  }

   componentDidMount(){
      ReactGA.set({ userId: this.props.user.id });
      ReactGA.initialize('UA-124053817-1');
      ReactGA.pageview('/tpo_registration');

        return

        let data = Object.assign({}, this.state.data)
        let componentState = Object.assign({}, this.state.componentState);
        data.testCycleId = 6
        return api.getTPOReferences(this.props.user.accessToken)
          .then((result) => {
            data.tpoRefereceList = result
            //this.setState({data: data})
        return api.getTeachingAssociations(this.props.user.accessToken)
        }).then((result) => {
            data.teachingAssociations = result
            //this.setState({data: data})
            return api.getTeachingAssociationOthers(this.props.user.accessToken)
        }).then((result) => {
            data.teachingAssociationOther = result
           // this.setState({data: data})
            return api.getWorkingPositions(this.props.user.accessToken)
        }).then((result) => {
            data.workingPositions = result
            return api.getuserForRegistration(this.props.user.accessToken)
        }).then((result) =>{
            data.firstName = result.data.firstName
            data.lastName = result.data.lastName
            data.email = result.data.email
            data.city = result.data.city
            data.stateId = result.data.stateId
            data.countryId = result.data.countryId

            if(data.firstName != '')
              componentState.first_disable = true
            if(data.firstName != '')
              componentState.last_disable = true

            return api.getCountries(this.props.user.accessToken)            
        }).then((result) => {
            var countryToPass = ''
            data.countries = result
            if(data.countryId != '')
              countryToPass = data.countryId
            else
              countryToPass = data.countries[0].id
            return api.getStates(this.props.user.accessToken, countryToPass)
        }).then((result) =>{
              data.states = result
            return api.getTestCenters(this.props.user.accessToken)
        }).then((result) =>{
              data.testcenters = result
              return api.getPaymentModes(this.props.user.accessToken)          
        }).then((result) =>{
             data.payment_modes = result
             this.setState({data: data, componentState: componentState})
        })
    }
 

    validateForm(){

      let error = true
      let errorObj = Object.assign({}, this.state.formErrors)
      let data = Object.assign({}, this.state.data)
      let timeSlots = Object.assign({}, this.state.timeSlots)


      errorObj.firstNameError = ''
      errorObj.lastNameError = ''
      errorObj.emailError = ''
      errorObj.teachingAssociationIdError =''
      errorObj.tpoReferenceError =''
      errorObj.cityOfResidenceError =''
      errorObj.paymentModeError = ''
      errorObj.testCenterError = ''
      errorObj.testTrackPrimaryIdError =''
      errorObj.primarySlotIdError =''
      errorObj.optionFirstSlotIdError =''
      errorObj.optionSecondSlotIdError =''
      errorObj.countryIdError = ''
      errorObj.workingOrganizationError = ''

      if(data.firstName === ''){
        errorObj.firstNameError ='First Name is mandatory'
        error = false
      }

      if(data.lastName === ''){
        errorObj.lastNameError ='Last Name is mandatory'
        error = false
      }

      if(!(data.email) || data.email === ''){
        errorObj.emailError ='Email is mandatory'
        error = false
      }
      else{
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(data.email)){
          errorObj.emailError ='Invalid Email Format'
          error = false
        }
      }

      /**if(data.countryId === ''){
        errorObj.countryIdError ='Country is mandatory'
        error = false
      }

      if(data.city === ''){
        errorObj.cityOfResidenceError ='City is mandatory'
        error = false
      }
      */

      if(data.teachingAssociationId === ''){
        errorObj.teachingAssociationIdError ='Occupation is mandatory'
        error = false
      }

      if(data.teachingAssociationId && !(data.teachingAssociationName === 'Student pursuing a Degree in Education' || data.teachingAssociationName === 'No association with teaching' || data.teachingAssociationName === 'Tuition Teacher')){
        if(data.workingOrganization  === ''){
          errorObj.workingOrganizationError ='Please enter the name of School/Organization/Institute'
          error = false
        }
      }

      if(data.tpo_reference === ''){
        errorObj.tpoReferenceError ='TPO (where did you hear) is mandatory'
        error = false
      }

      if(data.paymentModeId === ''){
        errorObj.paymentModeError = 'Payment is mandatory'
        error = false
      }

      if(data.testcenterId === ''){
        errorObj.testCenterError = 'Test Center is mandatory'
        error = false
      }

      if(data.testTrackPrimaryId === ''){
        errorObj.testTrackPrimaryIdError = 'Test Track Primary is mandatory'
        error = false
      }

      if(timeSlots.primarySlotId === ''){
        errorObj.primarySlotIdError = 'Time Slot for chosen track is mandatory'
        error = false
      }

      if(data.testTrackOptionFirstId !=='' && timeSlots.optionFirstSlotId === ''){
        errorObj.optionFirstSlotIdError = 'Time Slot for chosen track is mandatory'
        error = false
      }

      if(data.testTrackOptionSecondId !=='' && timeSlots.optionSecondSlotId === ''){
        errorObj.optionSecondSlotIdError = 'Time Slot for chosen track is mandatory'
        error = false
      }

      let saveState = Object.assign({}, this.state.saveState)
      if(!error){        
        saveState.saveDisabled = false
      }
      else{
        saveState.saveDisabled = true
      }

      this.setState({
        formErrors:errorObj,
        errorMsg:'',
        saveState: saveState
      })
      return error
    }
    
  handleSubmit(e) {
    e.preventDefault()
    this.processRegistration(false)
  }

  handleSubmitAndProceed(e){
    e.preventDefault()
    this.processRegistration(true)
  }

  processRegistration = (isPayment) => {
    
      let data = Object.assign({}, this.state.data)
      let timeSlots = Object.assign({}, this.state.timeSlots)
      if(this.validateForm()){
      //values start
      let apiInput = {
       'certification_participation': {
        'certification_type_id': '3',    
        },      
        'tpo_certification': {
          'tpo_reference_id': data.tpo_reference,
          'tpo_reference_sub': data.tpoReferenceSub,
          'working_organization': data.workingOrganization,
          'teaching_association_id': data.teachingAssociationId,
          'teaching_association_other_id': data.teachingAssociationIdOther,
          'working_position_id': data.workingPositionId,
          'test_center_id': data.testcenterId,
          'test_location_pref_one': data.testLocationOne,
          'test_location_pref_two': data.testLocationTwo,
          'referral_code': data.referralCode,
        },      
        'payment': {
          'payment_mode_id': data.paymentModeId,
          'currency': data.countryFee.currency_name
        },      
        'tpo_certification_detail': {
          'test_track_primary': data.testTrackPrimaryId,
          'test_track_first_option': data.testTrackOptionFirstId,
          'test_track_second_option': data.testTrackOptionSecondId,
          'time_slot_primary': timeSlots.primarySlotId,
          'time_slot_first_option': timeSlots.optionFirstSlotId,
          'time_slot_second_option': timeSlots.optionSecondSlotId,
        },
        'user':{
          'email': data.email,
        },
        'personal_info':{
          'first_name': data.firstName,
          'last_name': data.lastName,
        },
        'payment_option':{
          'is_payment': isPayment
        }
      }

      if(isPayment){
       ReactGA.set({ userId: this.props.user.id });    
       ReactGA.initialize('UA-124053817-1');
       ReactGA.event({
         category: 'Other',
         action: 'Save and Pay'
       });
     }
     else{
       ReactGA.set({ userId: this.props.user.id });
       ReactGA.initialize('UA-124053817-1');
       ReactGA.event({
         category: 'Other',
         action: 'Save Button'
       });
     }

      // values end
      api.saveTPoRegistrationLoggedin(this.props.user.accessToken,apiInput)
      .then((result) => {
             
        if(result.errors){
          let saveState = Object.assign({}, this.state.saveState)
          saveState.saveDisabled = false
          this.setState({ errorMsg: result.errors, saveState: saveState })
        }
        else{
          if(result.redirect_to)
          window.location.href = result.redirect_to;
          else
            this.props.history.push("/portal/app/my_registrations")
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })

      }
      
    }

    handleTPORefSelection(event){
      //console.log('inside tpo ref selection')
      let data = Object.assign({}, this.state.data)
      let tpoRefOther = false  
      if(event.target.value){
          let selectedOption = event.target.value
          var optionElement = event.target.childNodes[event.target.selectedIndex]
          data.tpo_reference = selectedOption
          data.tpoReferenceSub=''
          if(optionElement.getAttribute('data-name') === 'Others')
            tpoRefOther = true
          else{
            tpoRefOther = false
            api.getTpoReferenceSub(selectedOption)
            .then((result) => {
              data.tpoReferenceSubList = result
              this.setState({data: data})
            })
          }
      }
      else{
        data.tpo_reference =''
        data.tpoReferenceSub=''
        data.tpoReferenceSubList=[]
        tpoRefOther = false
      }
      this.setState({data: data, tpoRefOther: tpoRefOther})
      
    }

    handleTPORefSub(event){
      let data = Object.assign({}, this.state.data)
      if(event.target.value){
        let selectedOption = event.target.value
        data.tpoReferenceSub = selectedOption
        
      }
      else{
        data.tpoReferenceSub =''
      }
      this.setState({data: data})
    }

    handleTestLocationOne(event){
      let data = Object.assign({}, this.state.data)
      if(event.target.value){
        let selectedOption = event.target.value
        data.testLocationOne = selectedOption   
      }
      else{
        data.testLocationOne =''
      }
      this.setState({data: data})
    }

    handleTestLocationTwo(event){
      let data = Object.assign({}, this.state.data)
      if(event.target.value){
        let selectedOption = event.target.value
        data.testLocationTwo = selectedOption   
      }
      else{
        data.testLocationTwo =''
      }
      this.setState({data: data})
    }

    handleStatesChange(event){
      let data = Object.assign({}, this.state.data)
      if(event.target.value){
        let selectedOption = event.target.value
        data.stateId = selectedOption
        
      }
      else{
        data.stateId = ''
      }
      this.setState({data: data})
    }

    handleTeachingAssociationSelection(event){
        
      let data = Object.assign({}, this.state.data)
        data.teachingAssociationIdOther=''
        data.teachingAssociationNameOther=''
        data.workingPositionId = ''
        data.workingPositionName =''
        data.workingOrganization=''
      if(event.target.value){
        let selectedOption = event.target.value
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]
        data.teachingAssociationId = selectedOption
        data.teachingAssociationName = optionElement.getAttribute('data-name')
      }
      else{
        data.teachingAssociationId = ''
        data.teachingAssociationName = ''
        
      }

      this.setState({data: data})

    }

    handleTeachingAssociationOtherSelection(event){

        let selectedOption = event.target.value
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]
        let data = Object.assign({}, this.state.data)
        data.teachingAssociationIdOther = selectedOption
        data.teachingAssociationNameOther = optionElement.getAttribute('data-name')
        this.setState({data: data})
    }

    handleworkingPositionSelection(event){
        let selectedOption = event.target.value
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]
        let data = Object.assign({}, this.state.data)
        data.workingPositionId = selectedOption
        data.workingPositionName = optionElement.getAttribute('data-name')
        //console.log(optionElement.getAttribute('data-name'))
        this.setState({data: data})

    }

    handleCountriesChange(event) {  
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    if (optionElement)
      console.log("In handleCountriesChange : target = " + event.target.value + " " + optionElement.getAttribute('data-name'))

      let data = Object.assign({}, this.state.data)
      let countryChanged = false
        if (data.country_id === event.target.value)
          countryChanged = false
        else
          countryChanged = true

        data.countryId = event.target.value
        data.countryName = optionElement.getAttribute('data-name')
        if (countryChanged) {

          api.getStates(this.props.user.accessToken, data.countryId)
          .then((states) => {
            //console.log("GetStates");
            data.states = states
            data.stateId = ''
            this.setState({data: data})
          })
        } else {
          this.setState({data: data})
        }
    }

   handleCityChange(value) {
    let data = Object.assign({}, this.state.data)
    data.city = value
    this.setState({data: data})
  }

  handleCitySelect(address) {
    let data = Object.assign({}, this.state.data)
    data.city = address
    this.setState({data: data})
  }

  handleSchoolChange(value) {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleSchoolSelect(value) {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleTestCenterChange(event){
    //console.log('inside test center change')
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
      if(event.target.value){
      let selectedOption = event.target.value
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      
      //console.log(selectedOption)
      data.testcenterId = selectedOption
      data.testCenterName = optionElement.getAttribute('data-name')
      data.testCenterCountryId = optionElement.getAttribute('date-countryid')
      this.setState({data: data})

      if(data.testCenterCountryId !== this.state.data.testCenterCountryId){
        api.getTPOTestTracks(this.props.user.accessToken, data.testCenterCountryId)
          .then((testTrackPrimaryList) => {
            data.testTrackPrimaryList = testTrackPrimaryList
            data.testTrackPrimaryId = ''
            data.testTrackPrimaryName = ''
            data.testTrackOptionFirstList = testTrackPrimaryList
            data.testTrackOptionFirstId = ''
            data.testTrackOptionFirstName = ''
            data.testTrackOptionSecondList = testTrackPrimaryList
            data.testTrackOptionSecondId = ''
            data.testTrackOptionSecondName = ''
            data.noOfSelectedTrack = 0 
            //this.setState({data: data})
            return api.getTPOCountryFee(this.props.user.accessToken, data.testCenterCountryId)  
          }).then((result) =>{
              data.countryFee = result
              return api.getTPOLocation(this.props.user.accessToken, data.testcenterId)          
        }).then((result) =>{
              data.testLocations = result
              data.testLocationOne =''
              data.testLocationTwo =''
              this.setState({data: data})
                        
        })

        let trackFee = Object.assign({}, this.state.trackFee)
        trackFee.PrimaryFee =0
        trackFee.optionFirstFee =0
        trackFee.optionSecondFee =0
        trackFee.feeToBePaid = 0
        this.setState({trackFee: trackFee})
         
      }
      else{
        api.getTPOLocation(this.props.user.accessToken, data.testcenterId)          
        .then((result) =>{
              data.testLocations = result
              data.testLocationOne =''
              data.testLocationTwo =''
              this.setState({data: data})          
        })
      }
    }
    else{
       data.testcenterId = ''
       data.testCenterName = ''
       data.testLocationOne =''
       data.testLocationTwo =''
       data.testLocations =[]
       data.testCenterCountryId = ''
       data.testTrackPrimaryList = []
       data.testTrackPrimaryId = ''
       data.testTrackPrimaryName = ''
       data.testTrackOptionFirstList = []
       data.testTrackOptionFirstId = ''
       data.testTrackOptionFirstName = ''
       data.testTrackOptionSecondList = []
       data.testTrackOptionSecondId = ''
       data.testTrackOptionSecondName = ''
        let trackFee = Object.assign({}, this.state.trackFee)
        trackFee.PrimaryFee =0
        trackFee.optionFirstFee =0
        trackFee.optionSecondFee =0
        trackFee.feeToBePaid = 0
       let key = Object.keys(timeSlots)
       for (key in timeSlots) {
         if (timeSlots.hasOwnProperty(key)) {
          if(timeSlots[key] instanceof Array)
            timeSlots[key] =[]
          else
            timeSlots[key] =''
         }
        }
       this.setState({data: data, timeSlots:timeSlots, trackFee:trackFee})
    }


      
  }


  getTimeSlotForTrack(testTrackId, trackType, optionSequence){
    let timeSlots = Object.assign({}, this.state.timeSlots)
    api.getTPOTimeSlot(this.props.user.accessToken,testTrackId, trackType)
          .then((result) => {
                       
            if (Number(optionSequence) === 1){
              timeSlots.primarySlots = result
              timeSlots.primarySlotId =''
            }
            else if (Number(optionSequence) === 2) {
              timeSlots.optionFirstSlots = result
              timeSlots.optionFirstSlotId =''
            }
            else {  
              timeSlots.optionSecondSlots = result
              timeSlots.optionSecondSlotId =''
            }
            this.setState({timeSlots: timeSlots})

            console.log(this.state.timeSlots)
    })
  }

  computeFeeToBePaid(testTrackId, optionSequence){
    let trackFee = Object.assign({}, this.state.trackFee)
    api.getTPOTrackFee('',testTrackId)
      .then((result) => {
          if (Number(optionSequence) === 1){
            trackFee.PrimaryFee = result.data
          }
          else if (Number(optionSequence) === 2) {
            trackFee.optionFirstFee = result.data 
          }
          else if (Number(optionSequence) === 3){  
            trackFee.optionSecondFee = result.data
          }
          trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
          this.setState({trackFee: trackFee})
      
    }).catch((err) => {
        this.setState({ errorMsg: err.stack })
    })
  }

  handleTestTrackPrimaryChange(event){
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
    if(event.target.value){
      data.testTrackPrimaryId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackPrimaryName = optionElement.getAttribute('data-name')
      this.getTimeSlotForTrack(data.testTrackPrimaryId, 1, 1)
      this.computeFeeToBePaid(data.testTrackPrimaryId, 1)
      if(this.state.data.testTrackPrimaryId ===''){
        data.noOfSelectedTrack = data.noOfSelectedTrack + 1
        
      }
      
    }
    else{
      //console.log('inside track primary change else')
      data.testTrackPrimaryId = ''
      data.testTrackPrimaryName = ''
      timeSlots.primarySlotId = ''
      timeSlots.primaryStart = ''
      timeSlots.primaryStartM = ''
      timeSlots.primaryEnd = ''
      timeSlots.primaryEndM = ''

      let trackFee = Object.assign({}, this.state.trackFee)
      trackFee.PrimaryFee =0
      trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
      this.setState({trackFee: trackFee})

      if(this.state.data.testTrackPrimaryId !==''){
        data.noOfSelectedTrack = data.noOfSelectedTrack - 1
        
      }
    }
    this.setState({data: data, timeSlots: timeSlots})
  }

  handleTestTrackOptionFirstChange(event){
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
    if(event.target.value){
      data.testTrackOptionFirstId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackOptionFirstName = optionElement.getAttribute('data-name')
      this.getTimeSlotForTrack(data.testTrackOptionFirstId, 0, 2)
      this.computeFeeToBePaid(data.testTrackOptionFirstId, 2)  
      if(this.state.data.testTrackOptionFirstId ===''){
        data.noOfSelectedTrack = data.noOfSelectedTrack + 1
        
      }
    }
    else{
      data.testTrackOptionFirstId = ''
      data.testTrackOptionFirstName = ''
      timeSlots.optionFirstSlotId = ''
      timeSlots.optionFirstStart = ''
      timeSlots.optionFirstStartM = ''
      timeSlots.optionFirstEnd = ''
      timeSlots.optionFirstEndM = ''
      let trackFee = Object.assign({}, this.state.trackFee)
      trackFee.optionFirstFee =0
      trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
      this.setState({trackFee: trackFee})
      
      if(this.state.data.testTrackOptionFirstId !==''){
        data.noOfSelectedTrack = data.noOfSelectedTrack - 1
        
      }
    }
    this.setState({data: data, timeSlots: timeSlots})
  }

   handleTestTrackOptionSecondChange(event){
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
    if(event.target.value){
      data.testTrackOptionSecondId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackOptionSecondName = optionElement.getAttribute('data-name')
      this.getTimeSlotForTrack(data.testTrackOptionSecondId, 0, 3)
      this.computeFeeToBePaid(data.testTrackOptionSecondId, 3) 
      if(this.state.data.testTrackOptionSecondId ===''){
        data.noOfSelectedTrack = data.noOfSelectedTrack + 1
        
      }
    }
    else{
      data.testTrackOptionSecondId = ''
      data.testTrackOptionSecondName = ''
      timeSlots.optionSecondSlotId = ''
      timeSlots.optionSecondStart = ''
      timeSlots.optionSecondStartdM = ''
      timeSlots.optionSecondEnd = ''
      timeSlots.optionSecondEndM = ''
      let trackFee = Object.assign({}, this.state.trackFee)
      trackFee.optionSecondFee =0
      trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
      this.setState({trackFee: trackFee})

      if(this.state.data.testTrackOptionSecondId !==''){
        data.noOfSelectedTrack = data.noOfSelectedTrack - 1
        
      }
    }
    this.setState({data: data, timeSlots:timeSlots})
  }

  handleAddTestTrack(event){
    event.preventDefault()
    
    if(!(this.state.optionFirstEnable))
      this.setState({optionFirstEnable: true})
    else{
      if(!(this.state.optionSecondEnable))
        this.setState({optionSecondEnable: true})
    }
  }

  handleTimeSlotChange(event){
    let timeSlots = Object.assign({}, this.state.timeSlots)
    let optionElement = event.target.childNodes[event.target.selectedIndex]
    let optionSequence = optionElement.getAttribute('option-sequence')
    let start = optionElement.getAttribute('option-start')
    let end = optionElement.getAttribute('option-end')
    let startM = optionElement.getAttribute('option-startm')
    let endM = optionElement.getAttribute('option-endm')

    let timeSlotId = event.target.value
    if(optionSequence === '1'){
      timeSlots.primarySlotId = timeSlotId
      timeSlots.primaryStart = start
      timeSlots.primaryStartM = startM
      timeSlots.primaryEnd = end
      timeSlots.primaryEndM = endM
    }
    else if (optionSequence === '2'){
      timeSlots.optionFirstSlotId = timeSlotId
      timeSlots.optionFirstStart = start
      timeSlots.optionFirstStartM = startM
      timeSlots.optionFirstEnd = end
      timeSlots.optionFirstEndM = endM
    }
    else if (optionSequence === '3'){
      timeSlots.optionSecondSlotId = timeSlotId
      timeSlots.optionSecondStart = start
      timeSlots.optionSecondStartdM = startM
      timeSlots.optionSecondEnd = end
      timeSlots.optionSecondEndM = endM
    }
    this.setState({timeSlots: timeSlots})
    
  }

  checkTimeOverlap(optionSequence, start, StartM, end, endM){
    let overlap = false

    if(optionSequence === 1 || optionSequence === 2){
      //console.log('inside option seq 1  2')
      //Check with sequence 3
      if(this.isTimeSlotOverlap(start, end, StartM, endM, this.state.timeSlots.optionSecondStart,
            this.state.timeSlots.optionSecondStartdM, this.state.timeSlots.optionSecondEnd,
            this.state.timeSlots.optionSecondEndM))
        overlap = true
    }

    if(optionSequence === 1 || optionSequence === 3){
      //console.log('inside option seq 1  3')
      //Check with sequence 2
      if(this.isTimeSlotOverlap(start, end, StartM, endM, this.state.timeSlots.optionFirstStart,
            this.state.timeSlots.optionFirstStartM, this.state.timeSlots.optionFirstEnd,
            this.state.timeSlots.optionFirstEndM))
        overlap = true
    }

    if(optionSequence === 3 || optionSequence === 2){
      //console.log('inside option seq 3  2')
      //Check with sequence 1
      if(this.isTimeSlotOverlap(start, end, StartM, endM, this.state.timeSlots.primaryStart,
            this.state.timeSlots.primaryStartM, this.state.timeSlots.primaryEnd,
            this.state.timeSlots.primaryEndM))
        overlap = true
    }
    return overlap
  }

  isTimeSlotOverlap(start, end, startM, endM, existingStart, existingStartM, existingEnd, existingEndM){
    let overlap = false
    
    start = this.transformPMHours(start, startM)
    end = this.transformPMHours(end, endM)
    existingStart = this.transformPMHours(existingStart, existingStartM)
    existingEnd = this.transformPMHours(existingEnd, existingEndM)

    if((start >= existingStart && start <= existingEnd)
        || (end >= existingStart && end <= existingEnd)){
      overlap = true
      //console.log('inside overlap true setting')
    }
    return overlap
  }

  transformPMHours(hourVal, hourMeridien){
    hourVal = Number(hourVal)
    if(hourVal < 12 &&  hourMeridien === 'PM')
      hourVal = hourVal +12
    return hourVal
  }

  handlePaymentModeChange(event) {
    let data = Object.assign({}, this.state.data)
    data.paymentModeId = event.target.value
    this.setState({data: data})
  }

  handleDiscountApply(e) {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let formErrors = Object.assign({}, this.state.formErrors)
    let trackFee = Object.assign({}, this.state.trackFee)
    let totalFee = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
    api.getTPODiscountPerTrack(this.props.user.accessToken,3, this.state.data.referralCode, totalFee, '')
      .then((result) => {
        if(result.status === 'success'){
          data.discountValuePerTrack =  Number(result.discount)
          formErrors.discountCodeError = ''
        }
        else{
          data.discountValuePerTrack = 0
          formErrors.discountCodeError = result.message
        }
        trackFee.feeToBePaid = totalFee - data.discountValuePerTrack
        this.setState({data: data, trackFee: trackFee, formErrors: formErrors})
    })
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

    render() {
      let tpoRefSubComponent 
      if(this.state.tpoRefOther)
         tpoRefSubComponent = <TextField className="two-col-input" label="Please Specify" autoComplete="off" name="tpoReferenceSub" onChange={this.onInputChange} value={this.state.data.tpoReferenceSub}/>
      else{
        if(this.state.data.tpoReferenceSubList.length !=0) {
         tpoRefSubComponent =          
                      <Select
                        name="tpoReferenceSub"
                        onChange={this.handleTPORefSub}
                        value={this.state.data.tpoReferenceSub}
                        className="two-col-input tpo-reg-form-second-col"
                        placeholder='--Select Source--'
                      >
                        {this.state.data.tpoReferenceSubList.map(refSub => (
                          <option key={refSub.id} value={refSub.name} data-name={refSub.name}>
                            {refSub.name}
                          </option>
                        ))}
                      </Select>
        }
        
      }   
      
      //let handleTPORefSelection = this.handleTPORefSelection

      let TeachingOtherComponent
      let workingPositionComponent

      if(this.state.data.teachingAssociationName === 'Student pursuing a Degree in Education' ||
          this.state.data.teachingAssociationName === 'No association with teaching' || this.state.data.teachingAssociationName === 'Tuition Teacher'){
         /* TeachingOtherComponent = (<Select
                        name="teachingAssociation"
                        onChange={this.handleTeachingAssociationOtherSelection}
                        value={this.state.data.teachingAssociationIdOther}
                        className="two-col-input tpo-reg-form-second-col"
                        placeholder="--Select option for others--"
                      >
                        {this.state.data.teachingAssociationOther.map(level => (
                          <option key={level.id} value={level.id} data-name={level.name}>
                            {level.name}
                          </option>
                        ))}
                  </Select>
              )
        */
      }
      else if(this.state.data.teachingAssociationName !== '') {
                   
          /*if(!this.state.data.teachingAssociationName.startsWith('Studying in')){
            workingPositionComponent = (<Select
                          name="workingPosition"
                          onChange={this.handleworkingPositionSelection}
                          value={this.state.data.workingPositionId}
                          className="four-col-input tpo-reg-form-second-col"
                          placeholder="--- Select Role ---"
                        >
                          {this.state.data.workingPositions.map(level => (
                            <option key={level.id} value={level.id} data-name={level.name}>
                              {level.name}
                            </option>
                          ))}
                    </Select>)
          }*/
          TeachingOtherComponent = (
            
            <PlacesAutoComplete
          value={this.state.data.workingOrganization}
          onChange={this.handleSchoolSelect}
          onSelect={this.handleSchoolChange}
          >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div>
            <TextField
              {...getInputProps({
                placeholder: 'School/Organization/Institute',
                className: 'location-search-input'
              })}
              name="school"
              className="two-col-input"
            />
            <div className="autocomplete-dropdown-container">
              {suggestions.map(suggestion => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div {...getSuggestionItemProps(suggestion, { className, style })}>
                    <span>{suggestion.description}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
        </PlacesAutoComplete>
          )
      }


      let testTrackOptionFirstComponent
      let trackPrimarySelected = this.state.data.testTrackPrimaryId
      let trackOptionFirstSelected = this.state.data.testTrackOptionFirstId
      let trackOptionSecondSelected = this.state.data.testTrackOptionSecondId

      let testTrackOptionPrimaryComponent

      testTrackOptionPrimaryComponent = (
                                        <Select
                          name="testTrackPrimary"
                          onChange={this.handleTestTrackPrimaryChange}
                          value={this.state.data.testTrackPrimaryId}
                          className="tpo-track-slot-col"
                          placeholder="--- Select Test Track ---"
                        >
                          {this.state.data.testTrackPrimaryList.map(function(level){
                            if(level.id === Number(trackOptionFirstSelected) ||
                                level.id === Number(trackOptionSecondSelected)){
                              return (<option disabled key={level.id} value={level.id} data-name={level.name}>
                                {level.name}
                              </option> )
                            }
                            else{
                             return (<option key={level.id} value={level.id} data-name={level.name}>
                                {level.name}
                              </option> )
                            }
                          })}
                    </Select>
                    
                )

      if (this.state.optionFirstEnable){
        testTrackOptionFirstComponent = (
                                        <Select
                          name="testTrackOptionFirst"
                          onChange={this.handleTestTrackOptionFirstChange}
                          value={this.state.data.testTrackOptionFirstId}
                          className="tpo-track-slot-col"
                          placeholder="--- Select Optional Track ---"
                        >
                          {this.state.data.testTrackOptionFirstList.map(function(level){
                            if(level.id === Number(trackPrimarySelected) ||
                                level.id === Number(trackOptionSecondSelected)){
                              return (<option disabled key={level.id} value={level.id} data-name={level.name}>
                                {level.name}
                              </option> )
                            }
                            else{
                             return (<option key={level.id} value={level.id} data-name={level.name}>
                                {level.name}
                              </option> )
                            }
                          })}
                    </Select>
                  
                ) 
      }        

      let testTrackOptionSecondComponent
      if (this.state.optionFirstEnable && this.state.optionSecondEnable){
        testTrackOptionSecondComponent = (
                                        <Select
                          name="testTrackOptionSecond"
                          onChange={this.handleTestTrackOptionSecondChange}
                          value={this.state.data.testTrackOptionSecondId}
                          className="tpo-track-slot-col"
                          placeholder="--- Select Optional Track ---"
                        >
                          {this.state.data.testTrackOptionSecondList.map(function(level){
                            if(level.id === Number(trackPrimarySelected) ||
                                level.id === Number(trackOptionFirstSelected)){
                              return (<option disabled key={level.id} value={level.id} data-name={level.name}>
                                {level.name}
                              </option> )
                            }
                            else{
                             return (<option key={level.id} value={level.id} data-name={level.name}>
                                {level.name}
                              </option> )
                            }
                          })}
                    </Select>
                  
                ) 
      }     

      let timeSlotDisplay
      let optionFirstTimeSlotComponent
      let optionSecondTimeSlotComponent

      let checkTimeOverlapFn = this.checkTimeOverlap

      let primaryTimeSlotComponent = (
                                        <Select
                          name="primaryTimeSlot"
                          onChange={this.handleTimeSlotChange}
                          value={this.state.timeSlots.primarySlotId}
                          className="tpo-track-slot-col"
                          placeholder="--- Select Time Slot ---"
                        >
                          {this.state.timeSlots.primarySlots.map(function(level){
                              timeSlotDisplay = Number(level.start_time).toFixed(2)+level.start_time_meridiem+' '+'to'+' '+Number(level.end_time).toFixed(2)+level.end_time_meridiem+' '+level.time_zone
                              if(checkTimeOverlapFn(1, level.start_time, level.start_time_meridiem, level.end_time, level.end_time_meridiem)){
                                return (<option disabled key={level.id} value={level.id}
                                          option-sequence='1'
                                          option-start={level.start_time} option-startm={level.start_time_meridiem}
                                          option-end={level.end_time} option-endm={level.end_time_meridiem}
                                          >
                                  {timeSlotDisplay}
                                </option> )
                              }
                              else{
                                return (<option key={level.id} value={level.id}
                                          option-sequence='1'
                                          option-start={level.start_time} option-startm={level.start_time_meridiem}
                                          option-end={level.end_time} option-endm={level.end_time_meridiem}
                                          >
                                  {timeSlotDisplay}
                                </option> ) 
                              }
                          })}
                    </Select>
                    
                ) 
      if (this.state.optionFirstEnable){          
      optionFirstTimeSlotComponent = (
                                        <Select
                          name="optionFirstTimeSlot"
                          onChange={this.handleTimeSlotChange}
                          value={this.state.timeSlots.optionFirstSlotId}
                          className="tpo-track-slot-col"
                          placeholder="--- Select Time Slot ---"
                        >
                          {this.state.timeSlots.optionFirstSlots.map(function(level){
                              timeSlotDisplay = Number(level.start_time).toFixed(2)+level.start_time_meridiem+' '+'to'+' '+Number(level.end_time).toFixed(2)+level.end_time_meridiem+' '+level.time_zone
                              if(checkTimeOverlapFn(2, level.start_time, level.start_time_meridiem, level.end_time, level.end_time_meridiem)){
                                return (<option disabled key={level.id} value={level.id}
                                          option-sequence='2'
                                          option-start={level.start_time} option-startm={level.start_time_meridiem}
                                          option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                  {timeSlotDisplay}
                                </option> )
                              }
                              else{
                                return (<option key={level.id} value={level.id}
                                        option-sequence='2'
                                        option-start={level.start_time} option-startm={level.start_time_meridiem}
                                        option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                {timeSlotDisplay}
                              </option> )
                              }
                          })}
                    </Select>
                    
                ) 
      }

      if (this.state.optionFirstEnable && this.state.optionSecondEnable){
        optionSecondTimeSlotComponent= (
                                        <Select
                          name="optionSecondTimeSlot"
                          onChange={this.handleTimeSlotChange}
                          value={this.state.timeSlots.optionSecondSlotId}
                          className="tpo-track-slot-col"
                          placeholder="--- Select Time Slot ---"
                        >
                          {this.state.timeSlots.optionSecondSlots.map(function(level){
                              timeSlotDisplay = Number(level.start_time).toFixed(2)+level.start_time_meridiem+' '+'to'+' '+Number(level.end_time).toFixed(2)+level.end_time_meridiem+' '+level.time_zone
                              if(checkTimeOverlapFn(3, level.start_time, level.start_time_meridiem, level.end_time, level.end_time_meridiem)){
                                return (<option disabled key={level.id} value={level.id}
                                          option-sequence='3'
                                          option-start={level.start_time} option-startm={level.start_time_meridiem}
                                          option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                  {timeSlotDisplay}
                                </option> )
                              }
                              else{
                                return (<option key={level.id} value={level.id}
                                          option-sequence='3'
                                          option-start={level.start_time} option-startm={level.start_time_meridiem}
                                          option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                  {timeSlotDisplay}
                                </option> ) 
                              }  
                          })}
                              
                    </Select>
                    
                ) 
      }

      let feeToBePaidComponent
      if(this.state.data.countryFee.currency_name ==='RS' && this.state.trackFee.feeToBePaid && !(this.state.data.discountValuePerTrack >0)){
        let regFee = this.state.trackFee.feeToBePaid
        let regFeeWithoutGST = regFee / 1.18
        feeToBePaidComponent = <h4> Total registration fee {this.state.data.countryFee.currency_name} {this.state.trackFee.feeToBePaid}{'/-'} (Rs.{parseFloat(regFeeWithoutGST).toFixed(2)} + 18% GST)</h4>
      }
      else{
       feeToBePaidComponent = <h4> Total registration fee {this.state.data.countryFee.currency_name} {this.state.trackFee.feeToBePaid}{'/-'}</h4>  
      }


      let fullDiscountMsgComponent
      if(this.state.data.discountValuePerTrack >0 && this.state.trackFee.feeToBePaid === 0){
        fullDiscountMsgComponent = (<div className="success-style width-double"> 
          <Typography use="subtitle"> Thank you! Your registration fee for CENTA TPO 2020 is waived off. Please </Typography>
          <Typography use="subtitle"> 1) Select a method of payment (you will not be required to pay the registration fee). This is just to complete the registration process. You could choose any option.</Typography>
          <Typography use="subtitle"> 2) Click on Save.</Typography>
          </div>) 
      }
      
      let registerProceedButton
      if(this.state.data.paymentModeId === '4' || this.state.data.paymentModeId === '5' || this.state.data.paymentModeId === '6' || this.state.data.paymentModeId === '7'){
        registerProceedButton = (<Button raised onClick={this.handleSubmitAndProceed} className="confirm-proceed-button" disabled={this.state.saveState.saveDisabled}>Save & Pay</Button>)
      }

      let testTrackSelectMessage
      let registrationFeeMessage

      if(this.state.data.testTrackPrimaryList.length > 0) {
        testTrackSelectMessage = (<div className="width-double">
                              <Typography use="headline6">Please select your test track and time slot. Please note that TPO 2020 offers {this.state.data.testTrackPrimaryList.length} subject tracks to choose from.</Typography>
                              </div>)

        if(this.state.data.testCenterCountryId === '1'){
          //registrationFeeMessage = (<p>* Register at our early bird fee of Rs 590 inclusive of GST</p>)
        }

        else if (this.state.data.testCenterCountryId === '2'){
          //registrationFeeMessage = (<p>* Register at our early bird fee of AED 120</p>)
        }


      }
      else{
        testTrackSelectMessage = (<div className="width-double">
                           <Typography use="headline6">Please select your test track and time slot. Please note that TPO 2020 offers subject tracks to choose from.</Typography>
                          </div>)
      }

      let testCityCountryId = this.state.data.testCenterCountryId
      let paymentModeComponent =(
                    <Select
                      name="payment_mode"
                      onChange={this.handlePaymentModeChange}
                      value={this.state.data.paymentModeId}
                      className="select-component"
                      placeholder="--Select Payment Mode--"
                    >
          {this.state.data.payment_modes.map(function(level){
            if(level.id !== 2){
              if((testCityCountryId === '1' && (level.id === 4 || level.id === 5 || level.id === 6 || level.id === 7)))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>)
              
              else if((testCityCountryId === '2' && level.id === 3))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>) 
              }
            
                      })}
            </Select>
      )

      return (
        <div>
        <Card style={{padding: '25px', marginTop:'25px'}}>
            <Typography use="subtitle">Thank you for your interest in registering for CENTA Teaching Professionals' Olympiad (TPO) 2020. Please record your interest here and we will reach out to you: <a href="https://survey.zohopublic.com/zs/OeChdm" target="_blank"> https://survey.zohopublic.com/zs/OeChdm </a> </Typography>
        </Card>
        <div hidden class="mdc-layout-grid reg-form-background">
          <div class="mdc-layout-grid__inner"> 
            <div class="mdc-layout-grid__cell--span-10">
              <h2>TPO 2020 Registration</h2>
              <div></div>
              <div class="singleColumn">
                <form onSubmit={this.handleSubmit}>
                  <TextField label="First Name" autoComplete="off" name="firstName" onChange={this.onInputChange} value={this.state.data.firstName}/>
                  <TextField label="Last Name" disabled={this.state.componentState.last_disable} autoComplete="off"  name="lastName" onChange={this.onInputChange} value={this.state.data.lastName}/>
                  <TextField label="Email" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email}/>
                  <div className="width-double">
                  <Select
                        name="tpo_reference"
                        onChange={this.handleTPORefSelection}
                        value={this.state.data.tpo_reference}
                        className="two-col-input"
                        placeholder="--- Where did you hear about TPO ---"
                      >
                        {this.state.data.tpoRefereceList.map(level => (
                          <option key={level.name} value={level.id} data-name={level.name}>
                            {level.name}
                          </option>
                        ))}
                  </Select>
                  {tpoRefSubComponent}
                  </div>
                  <div className="width-double">
                    <br/>
                    <Select
                          name="teachingAssociation"
                          onChange={this.handleTeachingAssociationSelection}
                          value={this.state.data.teachingAssociation}
                          className="two-col-input"
                          placeholder="---Occupation---"
                        >
                          {this.state.data.teachingAssociations.map(level => (
                            <option key={level.id} value={level.id} data-name={level.name}>
                              {level.name}
                            </option>
                          ))}
                    </Select>
                    {TeachingOtherComponent}
                    
                    </div>
                  
                    
                  
                  <br/>
                  
                  
                  
                  <br/>
                  
                  <div className="width-double">
                  <Select
                        name="testcenter"
                        onChange={this.handleTestCenterChange}
                        value={this.state.data.testcenterId}
                        className="two-col-input"
                        placeholder="--- Select Test City ---"
                      >
                        {this.state.data.testcenters.map(testcenter => (
                          <option key={testcenter.id} value={testcenter.id} data-name={testcenter.name}
                            date-countryid = {testcenter.country_id}>
                            {testcenter.name}
                          </option>
                        ))}
                  </Select>
                  {this.state.data.testLocations.length !=0 &&
                  <Select
                        name="testlocationone"
                        onChange={this.handleTestLocationOne}
                        value={this.state.data.testLocationOne}
                        className="four-col-input tpo-reg-form-second-col"
                        placeholder="--Location Preference I --"
                      >
                        {this.state.data.testLocations.map(testlocation => (
                          <option key={testlocation.id} value={testlocation.name} data-name={testlocation.id}
                            locationpref = '1'>
                            {testlocation.name}
                          </option>
                        ))}
                  </Select>
                  }
                  {this.state.data.testLocations.length !=0 &&
                   <Select
                        name="testlocationtwo"
                        onChange={this.handleTestLocationTwo}
                        value={this.state.data.testLocationTwo}
                        className="four-col-input tpo-reg-form-second-col"
                        placeholder="--Location Preference II --"
                      >
                        {this.state.data.testLocations.map(testlocation => (
                          <option key={testlocation.id} value={testlocation.name} data-name={testlocation.id}
                            locationpref = '2'>
                            {testlocation.name}
                          </option>
                        ))}
                  </Select>
                  }
                  </div>
                  <br/>
                  {testTrackSelectMessage}

                  <br/>
                  <div className="width-double">
                    <p>* You can register for TPO in more than one test track (maximum of three); each track involves a separate fee. Common questions need to be taken only once, while subject-specific sections need to be taken separately for each track.</p>
                    {registrationFeeMessage}
                  </div>
                  <br/>
                  <div class="width-double">
                    {testTrackOptionPrimaryComponent}
                    {primaryTimeSlotComponent}
                  </div>
                  <div class="width-double">
                    {testTrackOptionFirstComponent}
                    {optionFirstTimeSlotComponent}
                  </div>
                  <div class="width-double">
                    {testTrackOptionSecondComponent}
                    {optionSecondTimeSlotComponent}
                  </div>
                  <br/>
                  <Button onClick={this.handleAddTestTrack}> Add Optional Track</Button>
                  {feeToBePaidComponent}
                  <div>
                    <div className="hidden-div">
                      <TextField className='text_input' label="Enter referral code (if any)" autoComplete="off" className="two-col-input" name="referralCode" onChange={this.onInputChange} value={this.state.data.referralCode}/>
                      <Button onClick={this.handleDiscountApply}>Apply</Button>
                      <StatusMessage error_msg = {this.state.formErrors.discountCodeError}/>
                    </div>
                    {fullDiscountMsgComponent}
                    <br/>
                    {paymentModeComponent}
                  </div>
                  <br/>
                  <div>
                    <Button raised disabled={this.state.saveState.saveDisabled}>Save</Button>
                    {registerProceedButton}
                  </div>
                </form> 
              </div>
              <StatusMessage error_msg = {this.state.errorMsg}/>
              <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.emailError}/>
              <StatusMessage error_msg = {this.state.formErrors.teachingAssociationIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.workingOrganizationError}/>
              <StatusMessage error_msg = {this.state.formErrors.tpoReferenceError}/>
              <StatusMessage error_msg = {this.state.formErrors.cityOfResidenceError}/>
              <StatusMessage error_msg = {this.state.formErrors.countryIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.paymentModeError}/>
              <StatusMessage error_msg = {this.state.formErrors.testTrackPrimaryIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.primarySlotIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.testCenterError}/>
              <StatusMessage error_msg = {this.state.formErrors.optionFirstSlotIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.optionSecondSlotIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.discountCodeError}/>

            </div>
            <div class="mdc-layout-grid__cell--span-1"></div>
            <div class="mdc-layout-grid__cell--span-1"></div>
          </div>
        </div>
        </div>
      )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPORegistration);


// WEBPACK FOOTER //
// ./src/views/TPORegistration.jsx